<!-- 権限エラーダイアログ -->
<template>
  <b-modal
    v-model="$store.state.error.AuthErrorModalShow"
    :title="'認証失敗'"
    :ok-title="'ログイン画面へ'"
    @ok="logout"
    ok-only
    hide-header-close
    footer-class="ok-only"
    no-close-on-backdrop>
    <p>要求された操作を行う権限がありません。</p>
  </b-modal>
</template>

<script>
export default {
  methods: {
    logout () {
      this.signOut()
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  text-align: left;
  margin-bottom: 0;
}
</style>
